import { TutorialDefinition, TutorialScene } from '../TutorialEngine.js';
import { COLORS, colorWithAlpha } from '../../rendering/Renderer.js';

const scenes: TutorialScene[] = [
    // Scene 1: Welcome
    {
        gameState: null,
        renderOptions: null,
        annotations: [
            { type: 'text-label', text: 'Welcome to the Grid!', cell: 'C1', anchor: 'center', color: COLORS.teal },
            { type: 'text-label', text: 'It is shared by 12 puzzles\nwith unique rules', cell: 'D3', anchor: 'center', color: COLORS.teal },
        ],
    },

    // Scene 2: Digits
    {
        gameState: null,
        renderOptions: null,
        annotations: [
            { type: 'text-label', text: 'You will often need to\nreach digits in order,\nor form a cycle between them', cell: 'C1', anchor: 'center' },
            { type: 'highlight', cells: ['E2', 'A3', 'D4'], color: colorWithAlpha('teal', 0.2) },
            { type: 'pulse', cell: 'E2', color: COLORS.teal },
            { type: 'pulse', cell: 'A3', color: COLORS.teal },
            { type: 'pulse', cell: 'D4', color: COLORS.teal },
        ],
    },

    // Scene 3: Challenge
    {
        gameState: null,
        renderOptions: null,
        annotations: [
            { type: 'text-label', text: 'Solve all 12 puzzles\nfor an extra challenge!', cell: 'C1', anchor: 'center', color: COLORS.purple },
        ],
    },

    // Scene 4: Scoring overview
    {
        gameState: null,
        renderOptions: null,
        annotations: [
            { type: 'text-label', text: 'When a puzzle is solved,\nyou get a score', cell: 'C1', anchor: 'center', color: COLORS.amber },
            { type: 'text-label', text: 'Lower scores are better\nUse fewer elements\nto improve your score', cell: 'D3', anchor: 'center', color: COLORS.amber },
        ],
    },
];

/**
 * Basics tutorial: 4 scenes on a 6x6 grid with digits 1-3.
 * General introduction to the Grid and its puzzles.
 */
export const BASICS_TUTORIAL: TutorialDefinition = {
    gameType: 'basics',
    gridCode: '6/1-3:1E2,2A3,3D4',
    scenes,
};
